import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const RegionWiseUserChart = ({ userCounts, scanningCounts }) => {
    const data = {
        labels: ['North', 'East', 'West', 'South'],
        datasets: [
            {
                label: 'User',
                data: userCounts,
                backgroundColor: '#ffc107', // Yellow
                barThickness: 5,
            },
            {
                label: 'Scanning',
                data: scanningCounts,
                backgroundColor: '#17a2b8', // Cyan
                barThickness: 5,
            },
        ],
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        barPercentage: 0.2,       // Controls width of bars within category
        categoryPercentage: 0.6,  // Controls spacing between groups
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
            },
            datalabels: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: { display: false },
                // max: 100,
                ticks: {
                    display: false, // 👈 Hides x-axis labels
                },

            },
            y: {
                grid: { display: false },
            },
        }
    };

    return (
        <div className='cdashboard_region_box'>
            <Bar data={data} options={options} />
        </div>
    );
};

export default RegionWiseUserChart;
